export const METRICS = [
  { key: "symmetry", label: "Facial Symmetry", short: "Symmetry", desc: "How balanced the left and right halves of your face are." },
  { key: "jawline", label: "Jawline & Definition", short: "Jawline", desc: "Sharpness and definition of the jaw and chin region." },
  { key: "facial_harmony", label: "Facial Harmony", short: "Harmony", desc: "How well all features work together as a whole." },
  { key: "golden_ratio", label: "Golden Ratio", short: "Golden Ratio", desc: "Alignment of proportions with the classical 1.618 ideal." },
  { key: "facial_thirds", label: "Facial Thirds", short: "Thirds", desc: "Balance between upper, middle and lower facial sections." },
  { key: "canthal_tilt", label: "Canthal Tilt", short: "Canthal Tilt", desc: "Angle of the eyes, a key driver of perceived attractiveness." },
  { key: "cheekbones", label: "Cheekbones", short: "Cheekbones", desc: "Prominence and positioning of the zygomatic bones." },
  { key: "skin_quality", label: "Skin Quality", short: "Skin", desc: "Clarity, evenness and texture of the skin." },
];

export const RATING_COLOR = {
  Elite: "text-primary",
  Great: "text-success",
  Good: "text-foreground",
  Average: "text-muted-foreground",
  Low: "text-destructive",
};
